import { datadogRum } from '@datadog/browser-rum'
import { reactPlugin } from '@datadog/browser-rum-react'
import { DATA_DOG_CLIENT_TOKEN, DATA_DOG_APPLICATION_ID } from '../../_config/authConfig'

datadogRum.init({
    applicationId: DATA_DOG_APPLICATION_ID || '',
    clientToken: DATA_DOG_CLIENT_TOKEN || '',
    site: 'datadoghq.com',
    service: process.env.REACT_APP_SERVICE_NAME,
    env: process.env.REACT_APP_ENV,
    // Specify a version number to identify the deployed version of your application in Datadog
    version: process.env.REACT_APP_VERSION,
    allowedTracingUrls: [
        // Function for advanced matching using env variable
        ...(process.env.REACT_APP_API_URL ? [process.env.REACT_APP_API_URL] : []),
        (url: string) => (process.env.REACT_APP_API_URL ? url.startsWith(process.env.REACT_APP_API_URL) : false),
    ],
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
    plugins: [reactPlugin({ router: true })],
})

// Optional: Start session replay recording
datadogRum.startSessionReplayRecording()
